export function getFirstDayOfMonth(
  year: number = new Date().getFullYear(),
  month: number = new Date().getMonth()
): Date {
  return new Date(year, month, 1)
}
